import React from 'react';

export const WINDOW_SERVER_COOKIES = '__SERVER_COOKIES__';

export function ServerCookieMarkup({
  serverCookies,
}: {
  serverCookies: Record<string, string>;
}) {
  return (
    <script
      type="application/json"
      data-server-cookie-markup
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(serverCookies),
      }}
    />
  );
}

export const getCookieDomainFromHostname = (hostname: string) => {
  const domainName = hostname.substring(hostname.indexOf('.') + 1);
  return `.${domainName}`;
};
